import Cookies from 'js-cookie'

const TokenKey = 'shfb-token'

export const FromKey = 'shfb-from'

let loginInfo = { isLogin: false, checkTime: null }

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // 返回登录会话
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLoginInfo() {
  return loginInfo
}

export function setLogin() {
  // 设置登录状态
  loginInfo = { isLogin: true, checkTime: new Date() }
}

export function removeLogin() {
  removeToken()
  // 设置登录状态
  loginInfo = { isLogin: false, checkTime: undefined }
}

// 获取登录来源
export function getFrom() {
  return Cookies.get(FromKey)

}
// 设置登录来源
export function setFrom(from) {
  // 返回登录会话
  return Cookies.set(FromKey, from)
}
// 删除登录来源
export function removeFrom() {
  // 返回登录会话
  return Cookies.remove(FromKey)
}
